import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Select} from 'antd'
import {toJS} from 'mobx'
import {UnlockOutlined, EditOutlined, LockOutlined, SearchOutlined, PlusOutlined} from '@ant-design/icons'
import azureAppRegistrationAPI from '../../apis/azureAppRegistrationAPI'
import {getPaginationConfig} from '../../components/pagination'
import AddModal from './components/AddModal'
import EditModal from './components/EditModal'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
class AzureAppRegistration extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    addModalVisible: false,
    editModalVisible: false,
    id: null,
    tableData: [],
    applicationNameList: []
  }
  formRef = React.createRef()

  componentDidMount() {
    this.handleSearch()
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        applicationName: fieldsValue.applicationName,
        status: fieldsValue.status,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      azureAppRegistrationAPI.getAzureList(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch(err => {

    })
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleEdit = (id) => {
    this.setState({
      editModalVisible: true,
      id
    })
  }

  handleLock = (record) => {
    let params = {
      id: record.id,
      status: record.status === 'Active' ? 'Inactive' : 'Active'
    }
    azureAppRegistrationAPI.lockAction(params).then(res => {
      this.handleSearch()
    })
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {location, t} = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange)

    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="applicationName" label={t(`azureAppRegistration.applicationName`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="status" label={t(`azureAppRegistration.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="Active" value="Active">Active</Select.Option>
                  <Select.Option key="Inactive" value="Inactive">Inactive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} offset={4} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>

        <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination}
               rowClassName={this.getRowClassName}>
          <Table.Column width={80} align="center" title={t(`azureAppRegistration.status`)} dataIndex="status" key="status" ellipsis={true}
                        render={(text) => <div style={{
                          display: 'inline-block',
                          height: 24,
                          width: 24,
                          lineHeight: '24px',
                          fontSize: 12,
                          borderRadius: 24,
                          color: 'white',
                          textAlign: 'center',
                          background: text === 'Active' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Inactive' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : 'none'
                        }} title={text}>{text.charAt(0)}</div>}
          />
          <Table.Column title={t(`azureAppRegistration.applicationName`)} dataIndex="applicationName" key="applicationName" ellipsis={true}/>
          <Table.Column title={t(`azureAppRegistration.applicationClient`)} dataIndex="applicationClient" key="applicationClient" ellipsis={true}/>
          <Table.Column title={t(`azureAppRegistration.directoryTenantId`)} dataIndex="directoryTenantId" key="directoryTenantId" ellipsis={true}/>
          <Table.Column title={t(`azureAppRegistration.expireDate`)} dataIndex="expireDate" key="expireDate" ellipsis={true}/>
          <Table.Column width={150} align="center" title={t(`general.action`)} key="Action" render={(record, index) => {
            return (
              <>
                <Button type="link" onClick={() => this.handleEdit(record.id)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
                {
                  record.status === 'Active' ? (
                    <Button type="link" onClick={() => this.handleLock(record)} icon={<UnlockOutlined/>} title={t(`general.active`)}/>
                  ) : (
                    <Button type="link" className="grey" onClick={() => this.handleLock(record)} icon={<LockOutlined/>}
                            title={t(`general.inactive`)}/>
                  )
                }
              </>
            )
          }}/>
        </Table>
        {this.state.addModalVisible ?
          <AddModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible}/> : null}
        {this.state.editModalVisible ? <EditModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} id={this.state.id}
                                                  editModalVisible={this.state.editModalVisible}/> : null}
      </div>
    )
  }
}

export default withTranslation()(AzureAppRegistration)
